// removed by extract-text-webpack-plugin
module.exports = {"subNav":"qempo_sub-nav_subNav-dGjZQ0S","orange":"qempo_sub-nav_orange-2XlUeNP","active":"qempo_sub-nav_active-3b3m_57","rightLink":"qempo_sub-nav_rightLink-1MOrARL"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/sub-nav.scss
// module id = 271
// module chunks = 0